import {
  FETCH_USER_DATA,
  FETCH_USER_REAL_DATA,
  FETCH_USER_DATA_TOHOME,
  FETCH_USER_DATA_ERROR,
  FETCH_USER_DATA_LOADING,
  REFRESH_TOKEN_INTERVAL_ID,
} from "../constants";
import { closeModal } from "../actions/AdministrationActions";
import { resetDataFlag } from "../storeFunctionUtils";

import client from "../apolloClient";
import gql from "graphql-tag";

export function userFetchData(noInit = true, isLogin = true) {
  return (dispatch, getState) => {
    if (noInit) {
      let initUser = {};
      dispatch(userFetchDataSuccess(initUser));
    }

    dispatch(userIsLoading(true));
    dispatch(userHasErrored(false));

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append("Authorization", `Bearer ${getState().jwt.jwt_token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    fetch(window.env.GetUserData, requestOptions)
      .then((result) => result.json())
      .then((data) => {
        data.role_id = data.userxteam[0].role_id;
        data.role = {
          id: data.userxteam[0].role_id,
          role_desc: data.userxteam[0].role.role_desc,
        };
        data.user_permissions = JSON.parse(data.userxteam[0].user_permissions);
        delete data.userxteam;
        dispatch(userFetchDataSuccess(data));
        dispatch(userIsLoading(false));
        dispatch(userHasErrored(false));
        if (isLogin) {
          dispatch(userToHome(true));
          resetDataFlag();
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch(userIsLoading(false));
        dispatch(userHasErrored(true));
      });
  };
}

export function impersonateUser(id) {
  return (dispatch) => {
    const query = gql`
      {
        simcaa_t_users(where: { id: { _eq: ${id} } }) {
          id
          name
          user
          email
          organization
          link_web
          active
          last_login
          idstaff
          role {
            id
            role_desc
          }
          staff {
            id
            name
          }
          userxteam {
            id
            role_id
            user_permissions
            role {
              role_desc
            }
          }
          created_at
          updated_at
        }
      }
    `;

    dispatch(userHasErrored(false));
    dispatch(userIsLoading(true));

    client.query({ query }).then((users) => {
      dispatch(userIsLoading(false));
      if (users.errors) {
        dispatch(userHasErrored(true));
      } else {
        dispatch(userHasErrored(false));
        let user = users.data.simcaa_t_users[0];
        // user.user_permissions = JSON.parse(user.user_permissions);
        user.user_permissions = JSON.parse(user.userxteam[0].user_permissions);
        user.role_id = user.userxteam[0].role_id;
        user.role = {
          id: user.userxteam[0].role_id,
          role_desc: user.userxteam[0].role.role_desc,
        };
        delete user.userxteam;
        dispatch(userFetchDataSuccess(user));
        dispatch(closeModal());
      }
    });
    // .catch(error => dispatch(userHasErrored(true)));
  };
}

export function userToHome(bool = false) {
  return (dispatch) => {
    let dispatchVar = {
      type: FETCH_USER_DATA_TOHOME,
      toHome: bool,
    };
    dispatch(dispatchVar);
  };
}

export function userHasErrored(bool) {
  return {
    type: FETCH_USER_DATA_ERROR,
    hasErrored: bool,
  };
}

export function userIsLoading(bool) {
  return {
    type: FETCH_USER_DATA_LOADING,
    isLoading: bool,
  };
}

export function userFetchDataSuccess(user) {
  return {
    type: FETCH_USER_DATA,
    user,
  };
}

export function userRealFetchDataSuccess(user) {
  return {
    type: FETCH_USER_REAL_DATA,
    user,
  };
}

export function refreshTokenIntervalID(id) {
  return {
    type: REFRESH_TOKEN_INTERVAL_ID,
    id,
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/UserActions.js